import { createSlice } from '@reduxjs/toolkit'
import { requests } from "api/index";
import URLS from "api/endPoints";

// Slice

const initialUser = {setCurrentUser:"",postUserRecord:"",generateDeclarationDoc:""}
   

const slice = createSlice({
  name: 'declaration',
  initialState: {
    declaration: initialUser,
  },
  reducers: {
  
    setCurrentUserDeclarationReducer: (state, action) => {
        state.declaration.setCurrentUser = action.payload;
    },
    postUserDeclarationReducer: (state, action) => {
      state.declaration.postUserRecord = action.payload
    },
    generateDeclarationDocReducer: (state, action) => {
        state.declaration.generateDeclarationDoc = action.payload;
    }
 
  },
});

export default slice.reducer

// Actions

const { setCurrentUserDeclarationReducer,postUserDeclarationReducer, generateDeclarationDocReducer} = slice.actions

export const setCurrentUserDeclarationAction = (payload) => async dispatch => {

    try {
    let response = await requests.getHC(  'career/getCandiadteDeclaration?candidateno=' + payload.HCID)
       
      await dispatch(setCurrentUserDeclarationReducer(response));
      return await returnCode(response)
    } catch (e) {
      return console.error(e.message);
    }
  }

export const postUserDeclarationAction = (payload) => async dispatch => {
    try {
      let response = await requests.postHC("Career/UpdateDeclaration", payload)
      await dispatch(postUserDeclarationReducer(response))
      return returnCode(response)

    } catch (error) {
      return console.error(error.message);
    }
  }

export const generateDeclarationDocAction = (payload) => async dispatch => {
     try {
       let response = await requests.getHC("career/generateDeclarationForm?candidateno=" + payload.HCID)
       await dispatch(generateDeclarationDocReducer(response))
        //       window.location.href = `${process.env.PUBLIC_URL}/admin/dashboard`;
       return returnCode(response)
     } catch (error) {
        return console.error(error.message);
     }
  
  }


  function returnCode(response) {
    if (response.ResponseCode == 100 || 200) {
      return response;
    } else if (response.ResponseCode == 103) {
      return 103;
    } else {
      return 101;
    }
  }